import React, { useEffect, useLayoutEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Button, Layout, Menu } from "antd";
import { routes } from "src/data/routes";
import { PoweroffOutlined } from "@ant-design/icons";
import { useAuth } from "src/hooks/auth.hook";
import { useUser } from "src/hooks/user.hook";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "src/components/language-switcher";
import { AccountSwitcher } from "src/components/account-switcher";
import { useAtom } from "jotai";
import { accountsAtom } from "src/store";

const { Header, Content } = Layout;
export default function PrivateRoute() {
  const { t } = useTranslation();
  let items = [
    {
      key: "1",
      label: t("accounts"),
      path: routes.ACCOUNTS,
      hidden: true
    },
    {
      key: "2",
      label: t("menu.investments"),
      path: routes.INVESTMENTS,
    },
    {
      key: "3",
      label: t("menu.products"),
      path: routes.PRODUCTS,
    },
    {
      key: "4",
      label: t("menu.transactions"),
      path: routes.TRANSACTIONS,
    },
  ];
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [defaultKey, setDefaultKey] = useState("1");
  const [accounts] = useAtom(accountsAtom);

  useLayoutEffect(() => {
    setDefaultKey(
      items.find((elt) => elt?.path.includes(location?.pathname))?.key || "1"
    );
  }, [location]);

  return (
    <Layout className="min-h-screen bg-wtm">
      <Header className="w-full flex justify-between">
        <div className="flex w-1/4 items-center">
          <img src="/logo.png" alt="" className="w-auto md:h-[45px]" />
        </div>
        <div className="flex w-3/4 justify-end">
          <Menu
            theme="dark"
            mode="horizontal"
            className="w-full flex justify-end"
            selectedKeys={[defaultKey]}
            items={accounts && accounts.length > 1 ? items : items.filter(e => !e.hidden)}
            onSelect={(info: any) => navigate(info?.item?.props?.path)}
          />
          <div className="flex items-center justify-center mx-2">
            <AccountSwitcher />
          </div>
          <div className="flex items-center justify-center mx-2">
            <LanguageSwitcher />
          </div>
          <div className="flex items-center justify-center ">
            <Button
              ghost
              className="text-white ml-2"
              icon={<PoweroffOutlined />}
              onClick={() => logout()}
            />
          </div>
        </div>
      </Header>

      <div className="h-[5rem] border-t flex flex-col justify-center align-start px-[50px]">
        <h3 className="text-xl">
          {t("hello")} <span className="font-bold">{user?.name}</span>
        </h3>
        <h2 className="text-gray-600">{user?.email}</h2>
      </div>
      <Content className="h-full lg:px-[50px] py-[20px] px-[10px] bg-wtm">
        <Outlet />
      </Content>
    </Layout>
  );
}
